module.exports = __webpack_public_path__ + "img/logo-company.bd1e0b8c.png";